import React, { FunctionComponent, Suspense, lazy } from "react";
import styles from "./IconViewer.module.scss";
import IconViewerProps from "./IconViewerProps.interface";

import combineClasses from "helpers/combine-classes";
import isBrowserContext from "helpers/isBrowserContext";

const Anchor = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Anchor"));
const ArrowBottomLeft = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ArrowBottomLeft"));
const ArrowBottomRight = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ArrowBottomRight"));
const ArrowLeft = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ArrowLeft"));
const ArrowRight = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ArrowRight"));
const ArrowTopRight = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ArrowTopRight"));
const ChevronRight = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/ChevronRight"));
const Download = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Download"));
const Email = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Email"));
const Facebook = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Facebook"));
const Handshake = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Handshake"));
const Instagram = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Instagram"));
const LinkedIn = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/LinkedIn"));
const Logo = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Logo"));
const Magnet = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Magnet"));
const Pause = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Pause"));
const Phone = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Phone"));
const Play = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Play"));
const Quote = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Quote"));
const Search = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Search"));
const Twitter = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Twitter"));
const YouTube = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/YouTube"));
const Talent = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Talent"));
const Talents = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Talents"));
const Tools = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Tools"));
const Lighthouse = lazy(() => import(/* webpackChunkName: "Icons" */"./Icons/Lighthouse"));

const ICON_TYPES: { [key: string]: any } = {
    // Static
    "anchor": Anchor,
    "arrow-bottom-left": ArrowBottomLeft,
    "arrow-bottom-right": ArrowBottomRight,
    "arrow-top-right": ArrowTopRight,
    "arrow-left": ArrowLeft,
    "arrow-right": ArrowRight,
    "chevron-right": ChevronRight,
    "download": Download,
    "email": Email,
    "facebook": Facebook,
    "handshake": Handshake,
    "instagram": Instagram,
    "linkedin": LinkedIn,
    "logo": Logo,
    "magnet": Magnet,
    "lighthouse": Lighthouse,
    "pause": Pause,
    "phone": Phone,
    "play": Play,
    "quote": Quote,
    "search": Search,
    "twitter": Twitter,
    "youtube": YouTube,
    "talent": Talent,
    "talents": Talents,
    "tools": Tools,
};

const IconViewer: FunctionComponent<IconViewerProps> = (props) => {
    const Icon = props.name ? ICON_TYPES[props.name] : null;

    return (
        <div className={combineClasses([styles.wrapper, props.className])}>
            {isBrowserContext() ? (
                <Suspense fallback={null}>
                    {Icon ? (
                        <Icon className={styles.icon} />
                    ) : null}
                </Suspense>
            ) : null}

            <svg viewBox={`0 0 ${props.aspectRatioX ?? 1} ${props.aspectRatioY ?? 1}`} className={styles.ratio} preserveAspectRatio="xMidYMid" xmlSpace="preserve" version="1.1"></svg>
        </div>
    );
};

export default IconViewer;